import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * AddMessage
 *
 * @private
 */
export const addMessage = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.actions.rpc.routingAssistant.AddMessageAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/routing-assistant/addMessage', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/routing-assistant/addMessage', {
      category: 'rpc',
      type: 'rpc/routing-assistant/addMessage',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on addMessage`,
      { tags: ['rpc', 'routing-assistant'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `addMessage call failed`,
      error,
    })
  }
})
